<template>
  <div class="page-content">
    <nav class="page-breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Inicio</li>
        <li class="breadcrumb-item active" aria-current="page">Vacaciones Proyectadas</li>
      </ol>
    </nav>

    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
              <h6 class="card-title mb-0">
                <i class="link-icon mr-2" data-feather="calendar"></i>
                Calendario Anual de Vacaciones
              </h6>

              <div class="d-flex align-items-center flex-wrap">
                <select class="custom-select mr-2 mb-2" v-model="anioSeleccionado" @change="procesarDatos()">
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>

                <!-- ✅ BUSCADOR DE PERSONAS (clásico) -->
                <div class="mr-2 mb-2" style="min-width: 280px;">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i data-feather="search"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="busquedaPersona"
                      @input="onBusquedaPersona()"
                      placeholder="Buscar persona (nombre o legajo)..."
                    />
                    <div class="input-group-append" v-if="busquedaPersona">
                      <button class="btn btn-outline-secondary" type="button" @click="limpiarBusquedaPersona()">
                        <i data-feather="x"></i>
                      </button>
                    </div>
                  </div>
                  <small class="text-muted d-block mt-1" v-if="busquedaPersona">
                    Filtrando por: <strong>{{ busquedaPersona }}</strong>
                  </small>
                </div>

                <!-- ✅ IMPRIMIR A4 -->
                <button class="btn btn-outline-primary mr-2 mb-2" @click="imprimirListadoA4()">
                  <i class="link-icon mr-1" data-feather="printer"></i> Imprimir detalle (A4)
                </button>

                <button class="btn btn-primary mb-2" @click="abrirModalCarga()">+ Cargar Vacaciones</button>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12 d-flex align-items-center flex-wrap">
                <div class="btn-group mr-3 mb-2" role="group">
                  <button type="button" class="btn btn-sm" :class="filtroActivo === 'todos' ? 'btn-primary' : 'btn-outline-primary'" @click="setFiltro('todos')">Todos</button>
                  <button type="button" class="btn btn-sm" :class="filtroActivo === 'operaciones' ? 'btn-primary' : 'btn-outline-primary'" @click="setFiltro('operaciones')">Operaciones</button>
                  <button type="button" class="btn btn-sm" :class="filtroActivo === 'administracion' ? 'btn-primary' : 'btn-outline-primary'" @click="setFiltro('administracion')">Administración</button>
                  <button type="button" class="btn btn-sm" :class="filtroActivo === 'planta' ? 'btn-primary' : 'btn-outline-primary'" @click="setFiltro('planta')">Planta</button>
                </div>

                <div class="mb-2" style="min-width: 300px;">
                  <Select2
                    v-model="sectorSeleccionado"
                    :options="listaSectoresUnicos"
                    :settings="{ placeholder: 'Buscar Sector/Operación específico...', allowClear: true, width: '100%' }"
                    @select="setFiltro('especifico')"
                  />
                </div>
              </div>
            </div>

            <div v-if="loading" class="text-center p-5">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2">Cargando datos...</p>
            </div>

            <div v-else>
              <!-- ✅ ALERTA: meses críticos y holgados -->
              <div
                class="alert alert-warning d-flex align-items-start justify-content-between flex-wrap mb-4"
                v-if="resumenMeses && resumenMeses.totalMesesConDatos > 0"
              >
                <div class="mr-3" style="flex: 1 1 520px;">
                  <div class="d-flex align-items-center mb-1">
                    <i class="mr-2" data-feather="alert-triangle"></i>
                    <strong>Informe rápido ({{ anioSeleccionado }}):</strong>
                  </div>

                  <div class="mb-1">
                    <span class="badge badge-danger mr-2">Más críticos</span>
                    <span v-if="resumenMeses.criticos.length === 0" class="text-muted">Sin datos.</span>
                    <span v-else>
                      <span v-for="(m, i) in resumenMeses.criticos" :key="'crit-'+i" class="mr-2">
                        <strong>{{ m.mes }}</strong>
                        <span class="badge badge-pill badge-danger">{{ m.personas }} p.</span>
                      </span>
                    </span>
                  </div>

                  <div>
                    <span class="badge badge-success mr-2">Más holgados</span>
                    <span v-if="resumenMeses.holgados.length === 0" class="text-muted">Sin datos.</span>
                    <span v-else>
                      <span v-for="(m, i) in resumenMeses.holgados" :key="'holg-'+i" class="mr-2">
                        <strong>{{ m.mes }}</strong>
                        <span class="badge badge-pill badge-success">{{ m.personas }} p.</span>
                      </span>
                    </span>
                  </div>

                  <small class="text-muted d-block mt-2">
                    Métrica: personas únicas con vacaciones que tocan el mes (según filtros actuales + buscador).
                  </small>
                </div>

                <div class="text-right" style="flex: 0 0 auto;">
                  <div class="mb-1">
                    <span class="badge badge-secondary">Promedio anual</span>
                    <span class="ml-2"><strong>{{ resumenMeses.promedio }}</strong> p/mes</span>
                  </div>
                  <div>
                    <span class="badge badge-secondary">Rango</span>
                    <span class="ml-2"><strong>{{ resumenMeses.min }}</strong> - <strong>{{ resumenMeses.max }}</strong></span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4 col-lg-3 mb-4" v-for="(mes, indexMes) in calendario" :key="indexMes">
                  <div class="card border shadow-sm">
                    <div class="card-header bg-light py-2 text-center font-weight-bold">
                      {{ nombresMeses[indexMes] }}
                      <span class="badge badge-secondary float-right">{{ mes.totalPersonasUnicas }} p.</span>
                    </div>
                    <div class="card-body p-2">
                      <div class="calendar-grid">
                        <div class="day-name">D</div><div class="day-name">L</div><div class="day-name">M</div>
                        <div class="day-name">M</div><div class="day-name">J</div><div class="day-name">V</div><div class="day-name">S</div>
                        <div v-for="blank in mes.espaciosVacios" :key="'b'+blank" class="day-cell empty"></div>
                        <div
                          v-for="dia in mes.dias"
                          :key="'d'+dia.numero"
                          class="day-cell"
                          :class="{'has-vacation': dia.cantidad > 0, 'weekend': dia.esFinde}"
                          @click="verDetalleDia(dia)"
                        >
                          <span class="day-number">{{ dia.numero }}</span>
                          <span v-if="dia.cantidad > 0" class="badge badge-pill" :class="getClassPorCantidad(dia.cantidad)">{{ dia.cantidad }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div><!-- v-else -->
          </div><!-- card-body -->
        </div><!-- card -->
      </div>
    </div>

    <!-- ✅ BLOQUE DE IMPRESIÓN (CLÁSICO) -->
    <div class="print-area">
      <div class="print-header">
        <h1>Detalle de Vacaciones Proyectadas</h1>
        <div class="print-meta">
          <span class="tag">{{ printFiltroTexto }}</span>
          <span class="tag">Generado: {{ printFechaGeneracion }}</span>
          <span class="tag">Registros: {{ vacacionesParaImprimir.length }}</span>
        </div>
      </div>

      <table class="print-table">
        <thead>
          <tr>
            <th>Personal</th>
            <th>Sector</th>
            <th>Rango</th>
            <th>Obs</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="vacacionesParaImprimir.length === 0">
            <td colspan="4" class="print-empty">Sin registros para imprimir con los filtros actuales.</td>
          </tr>

          <tr v-for="v in vacacionesParaImprimir" :key="'print-'+v.id">
            <td><strong>{{ v.legajo }}</strong> - {{ v.nombre }}</td>
            <td>{{ v.sector }}</td>
            <td>{{ formatDate(v.desde) }} al {{ formatDate(v.hasta) }}</td>
            <td>{{ v.obs || '' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="print-footer">
        <span>Vacaciones Proyectadas</span>
        <span>A4</span>
      </div>
    </div>

    <!-- MODALES -->
    <div class="modal fade" id="modalDetalle" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Vacaciones: {{ fechaDetalleFormat }}</h5>
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <div v-if="detalleDia.length === 0" class="alert alert-info">No hay registros.</div>
            <div v-else class="table-responsive">
              <table class="table table-sm table-hover">
                <thead><tr><th>Personal</th><th>Sector</th><th>Rango</th><th></th></tr></thead>
                <tbody>
                  <tr v-for="vaca in detalleDia" :key="vaca.id">
                    <td><strong>{{ vaca.legajo }}</strong> - {{ vaca.nombre }}</td>
                    <td>{{ vaca.sector }}</td>
                    <td><small>{{ formatDate(vaca.desde) }} al {{ formatDate(vaca.hasta) }}</small></td>
                    <td><button class="btn btn-xs btn-primary" @click="editarVacacion(vaca)">Editar</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalCarga" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-success text-white">
            <h5 class="modal-title">{{ editando ? 'Editar' : 'Nueva' }} Vacación</h5>
            <button type="button" class="close text-white" data-dismiss="modal"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <label class="fw-bold">Buscar Personal (API)</label>
              <Select2
                v-model="form.legajo"
                :options="listaPersonalAPI"
                :settings="{ dropdownParent: '#modalCarga', placeholder: 'Escriba nombre o legajo...', width: '100%' }"
                @select="alSeleccionarPersonal($event)"
              />
            </div>
            <div class="row mb-2">
              <div class="col-4"><label>Legajo</label><input type="text" class="form-control bg-light" v-model="form.legajo" readonly></div>
              <div class="col-8"><label>Sector</label><input type="text" class="form-control bg-light" v-model="form.sector" readonly></div>
            </div>
            <div class="row mb-3">
              <div class="col"><label>Desde</label><input type="date" class="form-control" v-model="form.desde"></div>
              <div class="col"><label>Hasta</label><input type="date" class="form-control" v-model="form.hasta"></div>
            </div>
            <div class="form-group"><label>Observaciones</label><textarea class="form-control" v-model="form.obs" rows="2"></textarea></div>
          </div>
          <div class="modal-footer">
            <button v-if="editando" class="btn btn-outline-danger mr-auto" @click="eliminarVacacion()">Eliminar</button>
            <button class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button class="btn btn-success" @click="guardarVacacion()">Guardar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
const jq = window.jQuery || window.$;
import axios from 'axios';
import feather from 'feather-icons';
import firebase from "firebase/app";
import "firebase/database";
import Select2 from 'vue3-select2-component';

export default {
  name: 'VacacionesProyectadas',
  components: { Select2 },
  data() {
    return {
      loading: true,
      anioSeleccionado: new Date().getFullYear(),
      nombresMeses: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
      listaVacacionesRaw: [],
      listaPersonalAPI: [],
      calendario: [],
      fechaDetalle: null,
      detalleDia: [],
      editando: false,
      idEdicion: null,
      form: { legajo: '', nombre: '', sector: '', sector_id: '', desde: '', hasta: '', obs: '' },

      // filtros
      filtroActivo: 'todos',
      sectorSeleccionado: null,

      // ✅ buscador persona
      busquedaPersona: '',

      // ✅ impresión (timestamp)
      printFechaGeneracion: '',

      idsPlanta: [
        "ASIGNACIÓN TEMPORAL/PLANTA","COCINA GOURMET/PLANTA","ARMADO/PLANTA","COCINA/PLANTA","PRE-ELABORADOS/PLANTA",
        "ARMADO - SAP/PLANTA","ARMADO - COMUN/PLANTA","ARMADO - GRANEL/PLANTA","ARMADO - EMPOTADO/PLANTA","COMEDOR/PLANTA"
      ],
      idsAdministracion: [
        "CALIDAD/PLANTA","MANTENIMIENTO/PLANTA","LOGISTICA/PLANTA","COORDINACION CATERING/PLANTA","COORDINACION SALIDA/PLANTA",
        "RELACIONES LABORALES/PLANTA","COMPRAS NO OPERATIVAS/PLANTA","CUENTAS A PAGAR/PLANTA","AUDITORIA/PLANTA","GESTION DE PROCESOS/PLANTA",
        "ADMINISTRACIÓN Y CONTABILIDAD/PLANTA","COMPRAS OPERATIVAS/PLANTA","SISTEMAS/PLANTA","COORDINACIÓN/PLANTA","PAGO A PROVEEDORES/PLANTA",
        "FACTURACIÓN/PLANTA","DIRECCIÓN/PLANTA","FINANZAS/PLANTA","CAPITAL HUMANO/PLANTA","SELECCIÓN/PLANTA","COSTOS Y PRESUPUESTOS/PLANTA",
        "LEGALES/PLANTA","CAPACITACIÓN/PLANTA","MARKETING/PLANTA","EVENTOS/PLANTA","SEGURIDAD E HIGIENE/PLANTA","JEFES DE SECTOR/PLANTA",
        "ATENCIÓN AL CLIENTE/PLANTA","ASISTENTES/PLANTA","PRICING/PLANTA","NUTRICIÓN/PLANTA","PRE-LEGALES/PLANTA","COBRANZAS/PLANTA"
      ],
      idsExtraOperaciones: [
        "CALIDAD/OPERACIONES","SECTOR ZONALES","PERSONAL SUPERNUMERARIO/CAPACITACION","VOLANTES","MANTENIMIENTO/OPERACIONES",
        "CAPACITACIÓN/OPERACIONES","JEFES REGIONALES","GERENTES/OPERACIONES"
      ]
    };
  },
  computed: {
    fechaDetalleFormat() {
      return this.fechaDetalle ? this.fechaDetalle.split('-').reverse().join('/') : '';
    },

    listaSectoresUnicos() {
      const sectoresMap = {};
      this.listaPersonalAPI.forEach(p => {
        if (p.sector_id) sectoresMap[p.sector_id] = p.sector;
      });
      return Object.keys(sectoresMap).sort().map(id => ({ id: String(id), text: sectoresMap[id] }));
    },

    // ✅ filtro central (año + sector + buscador persona + tipo filtro)
    vacacionesFiltradas() {
      const selId = (this.sectorSeleccionado && typeof this.sectorSeleccionado === 'object')
        ? String(this.sectorSeleccionado.id)
        : (this.sectorSeleccionado != null ? String(this.sectorSeleccionado) : null);

      const q = (this.busquedaPersona || '').trim().toLowerCase();

      const yStart = `${this.anioSeleccionado}-01-01`;
      const yEnd   = `${this.anioSeleccionado}-12-31`;

      return this.listaVacacionesRaw.filter(v => {
        const sName = v.sector ? String(v.sector) : null;
        const sId   = v.sector_id ? String(v.sector_id) : null;

        // toca el año
        if (!(v.desde <= yEnd && v.hasta >= yStart)) return false;

        // filtro por grupos
        if (this.filtroActivo === 'administracion') {
          if (!(sName && this.idsAdministracion.includes(sName))) return false;
        } else if (this.filtroActivo === 'planta') {
          if (!(sName && this.idsPlanta.includes(sName))) return false;
        } else if (this.filtroActivo === 'operaciones') {
          const esExtra = sName && this.idsExtraOperaciones.includes(sName);
          const noEsEspecial = sName && !this.idsAdministracion.includes(sName) && !this.idsPlanta.includes(sName);
          if (!(noEsEspecial || esExtra)) return false;
        } else if (this.filtroActivo === 'especifico') {
          if (selId && !(sId === selId)) return false;
        }

        // buscador persona (legajo o nombre)
        if (q) {
          const leg = (v.legajo != null ? String(v.legajo) : '').toLowerCase();
          const nom = (v.nombre != null ? String(v.nombre) : '').toLowerCase();
          let nomApi = '';
          if (!nom && v.legajo != null) {
            const p = this.listaPersonalAPI.find(x => String(x.legajo) === String(v.legajo));
            if (p && p.nombreCompleto) nomApi = String(p.nombreCompleto).toLowerCase();
          }
          if (!(leg.includes(q) || nom.includes(q) || nomApi.includes(q))) return false;
        }

        return true;
      });
    },

    // ✅ listado ordenado para imprimir
    vacacionesParaImprimir() {
      const data = (this.vacacionesFiltradas || []).slice();

      data.sort((a, b) => {
        const sa = (a.sector || '').toString().toLowerCase();
        const sb = (b.sector || '').toString().toLowerCase();
        if (sa < sb) return -1;
        if (sa > sb) return 1;

        const na = (a.nombre || '').toString().toLowerCase();
        const nb = (b.nombre || '').toString().toLowerCase();
        if (na < nb) return -1;
        if (na > nb) return 1;

        const da = (a.desde || '');
        const db = (b.desde || '');
        return da < db ? -1 : (da > db ? 1 : 0);
      });

      return data;
    },

    // ✅ texto filtros para impresión
    printFiltroTexto() {
      let parts = [];
      parts.push(`Año: ${this.anioSeleccionado}`);
      parts.push(`Filtro: ${this.filtroActivo}`);

      if (this.filtroActivo === 'especifico' && this.sectorSeleccionado) {
        const s = (typeof this.sectorSeleccionado === 'object') ? this.sectorSeleccionado.text : '';
        if (s) parts.push(`Sector: ${s}`);
      }
      if (this.busquedaPersona && this.busquedaPersona.trim()) parts.push(`Persona: "${this.busquedaPersona.trim()}"`);

      return parts.join(' | ');
    },

    // ✅ resumen meses críticos / holgados (usando calendario ya procesado)
    resumenMeses() {
      if (!this.calendario || this.calendario.length !== 12) {
        return { criticos: [], holgados: [], promedio: 0, min: 0, max: 0, totalMesesConDatos: 0 };
      }

      const arr = this.calendario.map((m, idx) => ({
        idx,
        mes: this.nombresMeses[idx],
        personas: Number(m.totalPersonasUnicas || 0)
      }));

      const totalMesesConDatos = arr.filter(x => x.personas > 0).length;
      const valores = arr.map(x => x.personas);
      const min = Math.min(...valores);
      const max = Math.max(...valores);
      const promedio = Math.round((valores.reduce((a,b)=>a+b,0) / (valores.length || 1)) * 10) / 10;

      const criticos = [...arr].sort((a,b)=> b.personas - a.personas || a.idx - b.idx).slice(0,2);
      const holgados = [...arr].sort((a,b)=> a.personas - b.personas || a.idx - b.idx).slice(0,2);

      return { criticos, holgados, promedio, min, max, totalMesesConDatos };
    }
  },
  watch: {
    sectorSeleccionado(nuevo) {
      const isEmpty = (nuevo == null) || (typeof nuevo === 'string' && nuevo.trim() === '');
      if (isEmpty && this.filtroActivo === 'especifico') {
        this.filtroActivo = 'todos';
        this.procesarDatos();
      }
    }
  },
  methods: {
    abrirModal(id) { jq(`#${id}`).modal('show'); },
    cerrarModal(id) { jq(`#${id}`).modal('hide'); },
    formatDate(dateStr) { return dateStr ? dateStr.split('-').reverse().join('/') : '-'; },

    refrescarFeather() {
      this.$nextTick(() => {
        try { feather.replace(); } catch (e) {}
      });
    },

    onBusquedaPersona() {
      this.procesarDatos();
      this.refrescarFeather();
    },
    limpiarBusquedaPersona() {
      this.busquedaPersona = '';
      this.procesarDatos();
      this.refrescarFeather();
    },

    async cargarDatosIniciales() {
      this.loading = true;
      try {
        await this.cargarPersonalAPI();
        await this.cargarVacacionesFirebase();
        this.procesarDatos();
      } catch (e) { console.error(e); }
      this.loading = false;
      this.refrescarFeather();
    },

    async cargarPersonalAPI() {
      const url = 'https://auth.foodservice.com.ar/index_dev.php?type=diagramafull&access_token=1234567';
      const res = await axios.get(url);
      let plano = [];
      if (res.data) {
        res.data.forEach(op => {
          if (op.personal) {
            op.personal.forEach(p => {
              plano.push({
                id: String(p.legajo),
                text: `${p.legajo} - ${p.nombre}`,
                legajo: String(p.legajo),
                nombreCompleto: p.nombre,
                sector: op.operacion_name,
                sector_id: String(op.operacion_id)
              });
            });
          }
        });
      }
      this.listaPersonalAPI = plano;
    },

    setFiltro(tipo) {
      this.filtroActivo = tipo;
      if (tipo !== 'especifico') this.sectorSeleccionado = null;
      this.procesarDatos();
      this.refrescarFeather();
    },

    alSeleccionarPersonal(item) {
      this.form.legajo = item.legajo;
      this.form.nombre = item.nombreCompleto;
      this.form.sector = item.sector;
      this.form.sector_id = item.sector_id;
    },

    async cargarVacacionesFirebase() {
      const snap = await firebase.database().ref('vacaciones_proyectadas').once('value');
      let raw = [];
      if (snap.val()) {
        Object.keys(snap.val()).forEach(k => {
          let item = { id: k, ...snap.val()[k] };

          // Parche para datos viejos que no tienen ID
          if (!item.sector_id && item.sector) {
            const refPersonal = this.listaPersonalAPI.find(p => p.sector === item.sector);
            if (refPersonal) item.sector_id = refPersonal.sector_id;
          }
          if (item.sector_id) item.sector_id = String(item.sector_id);

          // Parche: completar nombre si falta (para buscador / impresión)
          if (!item.nombre && item.legajo != null) {
            const p = this.listaPersonalAPI.find(x => String(x.legajo) === String(item.legajo));
            if (p && p.nombreCompleto) item.nombre = p.nombreCompleto;
          }

          raw.push(item);
        });
      }
      this.listaVacacionesRaw = raw;
    },

    // ✅ tu procesarDatos original, pero usando vacacionesFiltradas (ya incluye persona + filtros)
    procesarDatos() {
      let temp = [];
      let filtradas = this.vacacionesFiltradas;

      for (let m = 0; m < 12; m++) {
        let primerDia = new Date(this.anioSeleccionado, m, 1);
        let ultimoDia = new Date(this.anioSeleccionado, m + 1, 0);
        let diasArray = [];

        for (let d = 1; d <= ultimoDia.getDate(); d++) {
          let f = `${this.anioSeleccionado}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
          let vacs = filtradas.filter(v => f >= v.desde && f <= v.hasta);

          diasArray.push({
            numero: d,
            fechaCompleta: f,
            cantidad: vacs.length,
            detalle: vacs,
            esFinde: ([0,6].includes(new Date(this.anioSeleccionado, m, d).getDay()))
          });
        }

        const mesStart = `${this.anioSeleccionado}-${String(m+1).padStart(2,'0')}-01`;
        const mesEnd = `${this.anioSeleccionado}-${String(m+1).padStart(2,'0')}-${String(ultimoDia.getDate()).padStart(2,'0')}`;

        const personasMes = filtradas.filter(v => v.desde <= mesEnd && v.hasta >= mesStart);

        temp.push({
          espaciosVacios: primerDia.getDay(),
          dias: diasArray,
          totalPersonasUnicas: [...new Set(personasMes.map(x => x.legajo))].length
        });
      }

      this.calendario = temp;
      this.refrescarFeather();
    },

    verDetalleDia(dia) {
      this.fechaDetalle = dia.fechaCompleta;
      this.detalleDia = dia.detalle;
      this.abrirModal('modalDetalle');
    },

    abrirModalCarga() {
      this.editando = false;
      this.form = { legajo: '', nombre: '', sector: '', sector_id: '', desde: '', hasta: '', obs: '' };
      this.abrirModal('modalCarga');
    },

    editarVacacion(vaca) {
      this.editando = true;
      this.idEdicion = vaca.id;
      this.form = { ...vaca };
      this.cerrarModal('modalDetalle');
      this.abrirModal('modalCarga');
    },

    getClassPorCantidad(c) {
      return c <= 2 ? 'badge-success' : (c <= 5 ? 'badge-warning text-dark' : 'badge-danger');
    },

    async guardarVacacion() {
      if (!this.form.legajo || !this.form.desde) return alert("Faltan datos");
      const ref = firebase.database().ref('vacaciones_proyectadas');
      try {
        if (this.form.sector_id) this.form.sector_id = String(this.form.sector_id);
        if (this.editando) await ref.child(this.idEdicion).update(this.form);
        else await ref.push(this.form);

        this.cerrarModal('modalCarga');
        await this.cargarVacacionesFirebase();
        this.procesarDatos();
      } catch (error) {
        alert("Error al guardar");
      }
    },

    async eliminarVacacion() {
      if (confirm("¿Eliminar este registro?")) {
        await firebase.database().ref('vacaciones_proyectadas').child(this.idEdicion).remove();
        this.cerrarModal('modalCarga');
        await this.cargarVacacionesFirebase();
        this.procesarDatos();
      }
    },

    // ✅ IMPRESIÓN CLÁSICA: imprimir el bloque .print-area
    imprimirListadoA4() {
      const now = new Date();
      const fechaGen = `${String(now.getDate()).padStart(2,'0')}/${String(now.getMonth()+1).padStart(2,'0')}/${now.getFullYear()} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
      this.printFechaGeneracion = fechaGen;

      // esperar a que se actualice el texto (fecha / registros) y mandar imprimir
      this.$nextTick(() => {
        window.print();
      });
    }
  },
  mounted() {
    this.cargarDatosIniciales();
  }
};
</script>

<style scoped>
.calendar-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 1px; }
.day-name { font-size: 0.65rem; text-align: center; font-weight: bold; color: #999; }
.day-cell { border: 1px solid #f0f0f0; height: 40px; position: relative; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.day-cell:hover { background: #f8f9fa; }
.day-number { position: absolute; top: 1px; left: 3px; font-size: 0.7rem; color: #666; }
.weekend { background-color: #fcfcfc; }
.has-vacation { border-color: #ddd; }
.badge-pill { font-size: 0.7rem; padding: 4px 6px; }
.input-group-text svg { width: 16px; height: 16px; }

/* ✅ el bloque existe pero no se ve en pantalla */
.print-area { display: none; }
</style>

<style>
/* ✅ IMPRESIÓN (GLOBAL) - clásico, no rompe nada */
@page { size: A4; margin: 12mm; }

@media print {
  /* ocultar todo */
  body * { visibility: hidden !important; }

  /* mostrar SOLO print-area */
  .print-area, .print-area * {
    visibility: visible !important;
  }

  .print-area {
    display: block !important;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background: #fff;
    padding: 0;
  }

  .print-header h1 {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    margin: 0 0 6px 0;
    color: #111;
  }

  .print-meta {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 11px;
    color: #444;
    margin-bottom: 10px;
  }

  .print-meta .tag {
    display: inline-block;
    border: 1px solid #ddd;
    padding: 4px 8px;
    border-radius: 999px;
    margin-right: 6px;
    margin-bottom: 6px;
  }

  .print-table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, Helvetica, sans-serif;
    color: #111;
  }

  .print-table th, .print-table td {
    border: 1px solid #e6e6e6;
    padding: 6px 7px;
    font-size: 11px;
    vertical-align: top;
  }

  .print-table th {
    background: #f5f5f5;
    text-align: left;
  }

  .print-empty {
    text-align: center;
    padding: 14px !important;
  }

  .print-footer {
    margin-top: 10px;
    font-size: 10px;
    color: #666;
    display: flex;
    justify-content: space-between;
    font-family: Arial, Helvetica, sans-serif;
  }
}
</style>
